<template>
  <div>
    <div class="child-row__title pb-4">Outgoing messages</div>

    <MessagesTable :detailed="false" :base-filter="baseFilter" />
  </div>
</template>

<script lang="ts">
import type { Shipment } from '@/types/Models/Shipment'
import { defineComponent, computed, type PropType } from 'vue'
import MessagesTable from '@/views/Components/Messages/MessagesTable.vue'

export default defineComponent({
  name: 'ShipmentMessages',
  components: { MessagesTable },
  props: {
    shipment: {
      type: Object as PropType<Shipment>,
      required: true,
    },
  },
  setup(props) {
    const baseFilter = computed(() => ({ 'item[]': props.shipment.id }))

    return {
      baseFilter,
    }
  },
})
</script>
